import React, { useEffect, useState } from "react";
import { Dimensions, Text, TouchableOpacity, View } from "react-native";
import Header from "../../common/Header";
import * as RootNavigation from "../../utilities/RootNavigation";
import CImage from "../../common/CImage";
import CustomButton from "../../common/CustomButton";
import CustomInput from "../../common/CustomInput";
import { sendOtpApi, validateOtpApplyNow, getEncKey,getCpatcha } from "../../api/apiManager";
import LoginTabIcons from "./LoginTabIcons";
import LoginMoibleContent from "./LoginMobileContent";
import LoginFooter from "./LoginFooter";
import LoginRightWidget from "./LoginRightWidget";
import Loader from "../../common/Loader";
import CText from "../../common/CText";
import useStyles from "./CheckTagBalanceScreen_Styles";
import CCaptcha from "../../common/CCaptcha";
import CView from '../../styles/CommonStyle';
import { Encryption as encrypt,decryptCaptcha } from "../../utilities/Encryption";

const isSmallDevice = Dimensions.get("window").width < 450;

export default function CheckTagBalance(props) {
  const styles = useStyles();
  const otpPattern = /^\d{6}$/;
  const [screenName, setScreenName] = useState("1");
  const [loading, setLoading] = useState(false);
  const [vehicleNo, setVehicleNo] = useState("");
  const [reqID, setReqID] = useState("");
  const [enteredOTP, setEnteredOTP] = useState("");
  const [receivedBalance, setReceivedBalance] = useState("");
  const [otpDesc, setOtpDesc] = useState("");
  const [captcha, setCaptcha] = useState('');
  const [captchaId, setCaptchaId] = useState("");
  const [captchaText, setCaptchaText] = useState("");
  const [otpResponse, setOtpResponse] = useState("");
  useEffect(()=>{
    generateCaptcha();
  },[])

  const generateCaptcha = () => {
    setCaptcha("")
     getCpatcha()
       .then((res) => {
         decryptCaptcha(res?.data).then((res) => {
           setCaptchaText(res?.captchaCode)
           setCaptchaId(res?.captchaId)
         });
       }).catch((err) => {
         const routeObj = { title: "Captcha", type: "Error", msg: err?.response?.data?.message, btnText: "Ok", navigation: "Login", }
         RootNavigation.navigate("ResponseScreen", { data: routeObj })
       });
   };

   const handleSendOtpClick = () => {
    getEncKey()
      .then(async (res) => {
        if (res.statusCode == 200) {
          const encKey = res?.data || '';
          const encryptedCaptcha = await encrypt(`${captchaId}:${captcha}`, encKey);
          let reqObj = {
            type: 'tagBalanceCaptcha',
            vrn: vehicleNo,
            captcha: encryptedCaptcha,
          };
          onSendOtp(reqObj);
        }
      })
      .catch((err) => {
        const routeObj = { title: 'Login ', type: 'Error', msg: err?.response?.data?.message, btnText: 'Ok', navigation: 'Login' };
        RootNavigation.navigate('ResponseScreen', { data: routeObj });
      });
  };

  const onSendOtp = (reqObj) => {
    setLoading(true);
    sendOtpApi(reqObj)
      .then((res) => {
        setLoading(false);
        if (res.statusCode === 1003) {
          setReqID(res.response.otp);
          setOtpDesc(res.message);
          setScreenName("2")
          console.log("ghfghf", res);
          setOtpResponse(res.message);
        } else {
          const routeObj = {
            title: "Check Tag Balance",
            type: "error",
            msg: res.message,
            btnText: "Ok",
            navigation: "CheckTagBalance",
          };
          RootNavigation.navigate("ResponseScreen", { routeObj });
          setVehicleNo("");
        }
      })
      .catch((err) => {
        setLoading(false);
        const routeObj = {
          title: "Check Tag Balance",
          type: "error",
          msg: err.message,
          btnText: "Ok",
          navigation: "CheckTagBalance",
        };
        RootNavigation.navigate("ResponseScreen", { routeObj });
        setVehicleNo("");
      });
  };

  const handleValidateOtpClick = () => {
    setLoading(true);
    let reqObj = {
      requestId: reqID,
      otp: enteredOTP,
      type: "tagBalanceCaptcha",
      vrn: vehicleNo,
    };

    validateOtpApplyNow(reqObj)
      .then((res) => {
        setLoading(false);
        if (res.statusCode === 1008) {
          setScreenName("3");
          setReceivedBalance(res.data);
        } else if (
          res.statusCode === -1008 ||
          res.statusCode < 0 ||
          res.statusCode == 500
        ) {
          const routeObj = {
            title: "Check Tag Balance",
            type: "error",
            msg: res.message,
            btnText: "Ok",
            navigation: "CheckTagBalance",
          };
          RootNavigation.navigate("ResponseScreen", { routeObj });
        }
      })
      .catch((err) => {
        setLoading(false);
        const routeObj = {
          title: "Check Tag Balance",
          type: "error",
          msg: err.message,
          btnText: "Ok",
          navigation: "CheckTagBalance",
        };
        RootNavigation.navigate("ResponseScreen", { routeObj });
      });
  };

  const renderCheckBalanceUI = () => {
    return (
      <View style={styles.containerBox}>
        <View style={styles.rectangle41}>
          <TouchableOpacity onPress={() => RootNavigation.navigate("Login")}>
            <CImage.BackIconWhite></CImage.BackIconWhite>
          </TouchableOpacity>
          <CText.loginText style={{ justifyContent: "center", paddingLeft: 10 }}>
            {"Check Tag Balance"}
          </CText.loginText>
        </View>
        {(screenName == "1" || screenName == "2") ? (
          <View style={{ alignSelf: "center", width: "80%" }}>
            {
              screenName == "1" && <>
                  <CText.checkTaglabelStyle style={{ paddingTop: "10%", alignSelf: "center",}} >
                  {"Enter Vehicle NO."}
                </CText.checkTaglabelStyle>
                <CView W100 MB={20}>
                    <CCaptcha  captcha={captcha} setCaptcha={setCaptcha} setCaptchaText={setCaptchaText} setCaptchaId={setCaptchaId} captchaText= {captchaText}/>
                  </CView>
                <View>
                
                  <CustomInput
                    onValueChanged={(e) => setVehicleNo(e)}
                    value={vehicleNo}
                    style={[
                      styles.textInputStyle,
                      {
                        width: "100%",
                        height: 40,
                        paddingHorizontal: 10,
                        fontSize: 18,
                        textAlign: "flex-start",
                      },
                    ]}
                  />
                  
                  <TouchableOpacity
                    onPress={!vehicleNo  ?  ()=>{} :  !captchaText ? ()=>{} : captcha == captchaText ?  handleSendOtpClick :()=>{}}

                    style={[
                      styles.checkButtonStyle,
                      { backgroundColor: !vehicleNo  ?  "#aaaaaa" :  !captchaText ? "#aaaaaa" : captcha == captchaText ?  "#bd2d37" :"#aaaaaa",position: "absolute",zIndex: 999,top: 0,height: 40, right: 0,},
                    ]}
                  >
                    <CText.checkTagSubmitStyle>
                      {"Submit"}
                    </CText.checkTagSubmitStyle>
                  </TouchableOpacity>
                </View>
                <View>
                  <CText.checkOtpDesc style={{ paddingHorizontal: 20 }}>
                    {otpDesc}
                  </CText.checkOtpDesc>
                </View>
              </>
            }

            {
              screenName == "2" && <>
            <CText.enterOtpDescStyle
              style={{
                lineHeight: 12,
                marginHorizontal: "5%",
                paddingTop: 20,
                opacity: 0.5,
              }}
            >
              {otpResponse}
            </CText.enterOtpDescStyle>

                <CText.checkTaglabelStyle style={{paddingTop: "10%",paddingBottom: 20,alignSelf: "center", }} >
                {"Enter OTP"}
              </CText.checkTaglabelStyle>
              <View>
                <CustomInput
                  onValueChanged={(e) => setEnteredOTP(e)}
                  value={enteredOTP}
                  keyboardType="numeric"
                  pattern={/^\d{6}$/}
                  errorMessage={"Enter Valid OTP"}
                  maxLength={6}
                  style={[
                    styles.textInputStyle,
                    {
                      width: "100%",
                      height: 40,
                      paddingHorizontal: 10,
                      fontSize: 18,
                      textAlign: "flex-start",
                    },
                  ]}
                />
                <TouchableOpacity
                  onPress={
                    !otpPattern.test(enteredOTP) ? ()=>{} : handleValidateOtpClick
                  }
                  style={[
                    styles.checkButtonStyle,
                    {
                      backgroundColor: !enteredOTP || !otpPattern.test(enteredOTP) ? "#aaaaaa" : "#bd2d37",
                      position: "absolute",
                      zIndex: 999,
                      top: 0,
                      height: 40,
                      right: 0,
                    },
                  ]}
                >
                  <CText.checkTagSubmitStyle>
                    {"Submit"}
                  </CText.checkTagSubmitStyle>
                </TouchableOpacity>
              </View>
              </>
            }
          </View>
        ) : (
          <View>
            <View style={{ alignItems: "center", marginTop: isSmallDevice ? 0 : "5%",}} >
              <CText.tagBalanceDescStyle>
                {`Tag balance for ${vehicleNo} is`}
              </CText.tagBalanceDescStyle>

              <CText.tagBalanceAmountStyle>
                <CText.tagBalanceAmountStyle style={{ color: "#000000" }}>
                  {"\u20B9  "}
                </CText.tagBalanceAmountStyle>
                {`${receivedBalance}`}
              </CText.tagBalanceAmountStyle>
              <View
                style={{width: 108,height: 37,alignSelf: "center",marginTop: 20,}}  >
                <CustomButton
                  onPress={() => RootNavigation.navigate("Login")}
                  text={"Back To Login"}
                />
              </View>
            </View>
          </View>
        )}
      </View>
    );
  };

  return (
    <View style={styles.mainContainerStyle}>
      <View style={{ flex: 1 }}>
        <Header text={"Login"} />
        <View style={styles.bodyContainerStyle}>
          <View style={styles.bodyLeftViewStyle}>
            {renderCheckBalanceUI()}
            <LoginTabIcons />
          </View>
          <LoginRightWidget />
        </View>
        <View style={styles.mobileComponentStyle}>
          <View style={styles.logoWidget} >
            <View style={{ flexDirection: "row" }}>
              <CImage.IDFCLogo></CImage.IDFCLogo>
            </View>
            <View>
              <CImage.FFLogoSmall></CImage.FFLogoSmall>
            </View>
          </View>
          <View style={styles.renderWidget} >
            {renderCheckBalanceUI()}
          </View>

          <LoginMoibleContent />
        </View>

        <LoginFooter />
      </View>

      {loading && <Loader />}
    </View>
  );
}
